export default __webpack_public_path__ + "static/main_hero-1d60118950adaedfb8bedcb492faa07d.png";